export default __webpack_public_path__ + "static/media/juice-product.7dd02c69.png";